import { emitEvent, isTMA, mockTelegramEnv } from '@tma.js/sdk-react';

/**
 * In local dev, when the app is opened outside Telegram, install a mock
 * Telegram environment so `retrieveLaunchParams()` and the SDK components
 * resolve cleanly. Must be awaited from `bootstrap()` BEFORE the SDK reads
 * launch params — otherwise the mock arrives too late.
 *
 * In production (`vite build`) `import.meta.env.DEV` is false and Vite
 * tree-shakes the body away.
 */
export async function setupMockEnv(): Promise<void> {
  if (!import.meta.env.DEV) return;
  if (await isTMA('complete')) return;

  const themeParams = {
    accent_text_color: '#00E7DF',
    bg_color: '#000000',
    button_color: '#00E7DF',
    button_text_color: '#003737',
    destructive_text_color: '#D8403D',
    header_bg_color: '#000000',
    hint_color: '#9A9A9A',
    link_color: '#00E7DF',
    secondary_bg_color: '#191c1c',
    section_bg_color: '#000000',
    section_header_text_color: '#00E7DF',
    subtitle_text_color: '#9A9A9A',
    text_color: '#e0e3e2',
  } as const;
  const noInsets = { left: 0, top: 0, right: 0, bottom: 0 } as const;

  mockTelegramEnv({
    onEvent(e) {
      if (e.name === 'web_app_request_theme') {
        return emitEvent('theme_changed', { theme_params: themeParams });
      }
      if (e.name === 'web_app_request_viewport') {
        return emitEvent('viewport_changed', {
          height: window.innerHeight,
          width: window.innerWidth,
          is_expanded: true,
          is_state_stable: true,
        });
      }
      if (e.name === 'web_app_request_content_safe_area') {
        return emitEvent('content_safe_area_changed', noInsets);
      }
      if (e.name === 'web_app_request_safe_area') {
        return emitEvent('safe_area_changed', noInsets);
      }
    },
    launchParams: new URLSearchParams([
      ['tgWebAppThemeParams', JSON.stringify(themeParams)],
      [
        'tgWebAppData',
        new URLSearchParams([
          ['auth_date', ((new Date().getTime() / 1000) | 0).toString()],
          ['hash', 'mock-hash'],
          ['signature', 'mock-signature'],
          [
            'user',
            JSON.stringify({
              id: 1,
              first_name: 'QLASH',
              last_name: 'Dev',
              username: 'qlash_dev',
            }),
          ],
        ]).toString(),
      ],
      ['tgWebAppVersion', '8.4'],
      ['tgWebAppPlatform', 'tdesktop'],
    ]),
  });


  console.info(
    '[QLASH] Telegram environment mocked for local dev. This warning will not appear in production builds.',
  );
}
